module.exports = __webpack_public_path__ + "static/media/sslv3.3423c274.png";